// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3B9sW","left":"styles_left__3pkJF"};